document.addEventListener('DOMContentLoaded', function () {
  // Ocultar párrafos vacíos dentro de .post_body
  const postBody = document.querySelector('.post_body');

  if (postBody) {
    const paragraphs = postBody.querySelectorAll('p');
    paragraphs.forEach(p => {
      // Limpiar texto de espacios normales y non-breaking spaces (\u00A0)
      const cleanText = p.textContent.replace(/\u00A0/g, ' ').trim();

      // Verificar si tiene hijos importantes (imágenes, iframes, etc.)
      const hasImportantChildren = p.querySelector('img, iframe, input, svg, hr, video');

      // Si no tiene texto válido y no tiene hijos importantes, ocultarlo
      if (!cleanText && !hasImportantChildren) {
        p.style.display = 'none';
      }
    });
  }


  /** @type {any} */
  const _w = window;
  const nav = document.querySelector('.post_navigation');
  const shareBtn = nav ? nav.querySelector('.share') : null;

  if (shareBtn) {
    shareBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      const title = this.dataset.shareTitle || document.title;
      const text = this.dataset.shareText || '';
      const url = this.dataset.shareUrl || location.href;

      if (navigator.share) {
        try { await navigator.share({ title, text, url }); }
        catch (err) { /* ignore user cancel */ }
      } else {
        try {
          await navigator.clipboard.writeText(url);
          alert('Link copied to clipboard');
        } catch {
          window.prompt('Copy this link:', url);
        }
      }
    });
  }

  const SwiperCtor = _w.Swiper;
  if (typeof SwiperCtor === 'function' && document.querySelector('.post-swiper')) {
    const swiper = new SwiperCtor('.post-swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      loop: true,
      spaceBetween: 10,
    });
  }

  
});